import { valueFormat } from '@intelligence/utils/commonUtils';

const isIntegerAxisTick = (value: number): boolean =>
  Number.isInteger(value) || Math.abs(value - Math.round(value)) <= 1e-8;

/** Roblox Top Charts 折线图 Y 轴：与表格 value 一致（K / M / B） */
export const formatRobloxMetricChartYAxisLabel = (value: number): string | number => {
  if (!Number.isFinite(value)) {
    return '';
  }

  if (!isIntegerAxisTick(value)) {
    return '';
  }

  const formatted = valueFormat(value, true);
  return formatted === '-' ? '' : formatted;
};

/** Roblox Game Rank 折线图 Y 轴：排名整数刻度 */
export const formatRobloxRankChartYAxisLabel = (value: number): string | number => {
  if (!Number.isFinite(value)) {
    return '';
  }

  if (!isIntegerAxisTick(value)) {
    return '';
  }

  return Math.round(value);
};
